document.addEventListener('DOMContentLoaded', function() {
    const toggleButton = document.querySelector('.js-toggle-mobile-nav');
    const mobileNav = document.querySelector('.header-mobile-nav');

    if ( toggleButton && mobileNav ) {
        toggleButton.addEventListener('click', function() {
            toggleButton?.classList.toggle('is-active');
            mobileNav?.classList.toggle('is-active');
        });
    }


    function adjustHeaderHeight() {
        var viewportHeight = window.innerHeight;
        var newMaxHeight = viewportHeight - 100;
        
        var headerNav = document.querySelector('.js-mobile-nav-height');
        if (headerNav) {
            headerNav.style.maxHeight = newMaxHeight + 'px';
        }
    }
    
    window.addEventListener('load', adjustHeaderHeight);
    window.addEventListener('resize', adjustHeaderHeight);

});